import {
  ISubheaderBiClickType,
  SUBHEADER_BI_CLICK_TYPES,
} from './CommunityNavSubHeaderMobile/useCommunityNavSubHeaderBi';

export const DROPDOWN_IDS = ['connect', 'learn', 'share'] as const;
export type DropdownId = (typeof DROPDOWN_IDS)[number];

const LinkTypes = {
  internal: 'internal',
  external: 'external',
} as const;
export type LinkType = (typeof LinkTypes)[keyof typeof LinkTypes];
export interface CommunityNavDropdownOption {
  id: string;
  hrefKey: string;
  labelKey: string;
  linkType?: LinkType;
  clickType?: ISubheaderBiClickType;
}

export const COMMUNITY_NAV_DROPDOWN_OPTIONS: Record<
  DropdownId,
  readonly CommunityNavDropdownOption[]
> = {
  connect: [
    {
      id: 'partners-directory',
      hrefKey:
        'marketplace.community-nav-sub-header.connect.partners-directory-link',
      labelKey:
        'marketplace.community-nav-sub-header.connect.partners-directory-label',
      linkType: 'external',
    },
    {
      id: 'studio-league',
      hrefKey:
        'marketplace.community-nav-sub-header.connect.studio-league-link',
      labelKey:
        'marketplace.community-nav-sub-header.connect.studio-league-label',
      linkType: 'external',
    },
    {
      id: 'community-forum',
      hrefKey:
        'marketplace.community-nav-sub-header.connect.community-forum-link',
      labelKey:
        'marketplace.community-nav-sub-header.connect.community-forum-label',
      linkType: 'external',
    },
  ],
  learn: [
    {
      id: 'tutorials',
      hrefKey: 'marketplace.community-nav-sub-header.learn.tutorials-link',
      labelKey: 'marketplace.community-nav-sub-header.learn.tutorials-label',
      linkType: 'external',
    },
    {
      id: 'roadmap',
      hrefKey: 'marketplace.community-nav-sub-header.learn.roadmap-link',
      labelKey: 'marketplace.community-nav-sub-header.learn.roadmap-label',
      linkType: 'external',
    },
    {
      id: 'inspiration',
      hrefKey: 'marketplace.community-nav-sub-header.learn.inspiration-link',
      labelKey: 'marketplace.community-nav-sub-header.learn.inspiration-label',
      linkType: 'external',
    },
  ],
  share: [
    {
      id: 'templates-marketplace',
      hrefKey:
        'marketplace.community-nav-sub-header.share.templates-marketplace-link',
      labelKey:
        'marketplace.community-nav-sub-header.share.templates-marketplace-label',
      linkType: 'external',
      clickType: SUBHEADER_BI_CLICK_TYPES.studioTemplates,
    },
    {
      id: 'sell-studio-templates',
      hrefKey:
        'marketplace.community-nav-sub-header.share.sell-studio-templates-link',
      labelKey:
        'marketplace.community-nav-sub-header.share.sell-studio-templates-label',
      linkType: 'external',
      clickType: SUBHEADER_BI_CLICK_TYPES.sellInStudioTemplates,
    },
  ],
} as const;
